import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@mui/material'
import { ResourceVersionArtifactType } from '../../types'
import util from '../../helpers/util.helper'

interface DownloadFileContainerProps{
    artifact: ResourceVersionArtifactType,
    file: Blob
}

export default function DownloadFileContainer({file, artifact}: DownloadFileContainerProps) {
  return (
    <div className='d-flex-center' style={{ flexDirection: 'column' }}>
        <FontAwesomeIcon icon="file-download" className='gray' style={{ fontSize: '8rem', margin: ' 2rem auto' }} />
        <Button variant='contained' className='app-btn-color-third' type="submit" onClick={() => util.downloadFile(artifact.name, file)}>
          Descargar {artifact.name}
        </Button>
      </div>
  )
}
